module.exports = __webpack_public_path__ + "static/media/Mama Rochel - Medical Statement.23a68f9d.pdf";